import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, MapPin, Calendar, Clock, User } from 'lucide-react';
import { jobs } from '../../data/mockData';

export default function JobRequest() {
  const { id } = useParams();
  const navigate = useNavigate();
  const job = jobs.find(j => j.id === id);

  if (!job) {
    return <div>Job not found</div>;
  }

  const handleAccept = () => {
    alert('Job accepted! The customer will be notified.');
    navigate('/plumber/dashboard');
  };

  const handleDecline = () => {
    if (window.confirm('Are you sure you want to decline this job?')) {
      navigate('/plumber/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="text-gray-600 hover:text-gray-900">
            <ArrowLeft size={24} />
          </button>
          <h2 className="text-[#1E3A8A]">Job Request</h2>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="bg-white rounded-lg p-6 shadow-sm space-y-6">
          {/* Customer Info */}
          <div className="flex items-center gap-4 pb-6 border-b border-gray-200">
            <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
              <User size={32} className="text-gray-500" />
            </div>
            <div>
              <h3 className="text-[#1E3A8A] mb-1">{job.customerName}</h3>
              <p className="text-sm text-gray-600">Customer</p>
            </div>
          </div>

          {/* Job Details */}
          <div className="space-y-4">
            <div>
              <h3 className="text-[#1E3A8A] mb-4">Job Details</h3>
            </div>

            <div className="flex items-start gap-3">
              <div className="text-[#006C35] mt-1">🔧</div>
              <div>
                <div className="text-sm text-gray-600">Service</div>
                <div className="text-[#1E3A8A]">{job.service}</div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <MapPin className="text-[#006C35] mt-1" size={20} />
              <div>
                <div className="text-sm text-gray-600">Location</div>
                <div className="text-[#1E3A8A]">{job.location}</div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Calendar className="text-[#006C35] mt-1" size={20} />
              <div>
                <div className="text-sm text-gray-600">Date</div>
                <div className="text-[#1E3A8A]">
                  {new Date(job.date).toLocaleDateString('en-US', { 
                    weekday: 'short', 
                    month: 'short', 
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Clock className="text-[#006C35] mt-1" size={20} />
              <div>
                <div className="text-sm text-gray-600">Time</div>
                <div className="text-[#1E3A8A]">{job.time}</div>
              </div>
            </div>

            {job.description && (
              <div className="p-4 bg-gray-50 rounded-lg">
                <div className="text-sm text-gray-600 mb-1">Description</div>
                <p className="text-gray-800">{job.description}</p>
              </div>
            )}
          </div>

          {/* Payment */}
          <div className="border-t border-gray-200 pt-6">
            <h3 className="text-[#1E3A8A] mb-4">Payment</h3>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Service Fee</span>
                <span className="text-[#1E3A8A]">{job.price} SAR</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Platform Fee</span>
                <span className="text-red-600">-{job.platformFee} SAR</span>
              </div>
              <div className="border-t border-gray-200 pt-2 flex justify-between">
                <span>You will receive</span>
                <span className="text-[#006C35]">{job.price - job.platformFee} SAR</span>
              </div>
            </div>
          </div>

          {/* Distance Info */}
          {job.distance && (
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center gap-2 text-[#1E3A8A]">
                <MapPin size={20} />
                <span>{job.distance} km away from your location</span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Fixed Bottom Buttons */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4">
        <div className="max-w-4xl mx-auto grid grid-cols-2 gap-4">
          <button 
            onClick={handleDecline}
            className="px-6 py-4 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Decline
          </button>
          <button 
            onClick={handleAccept}
            className="px-6 py-4 bg-[#006C35] text-white rounded-lg hover:bg-[#005428] transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
